const MIN_LENGTH = 5;

export const fillArrayWithNullValues = (array: ReadonlyArray<any>): ReadonlyArray<any> => {
    return array.length < MIN_LENGTH ? [...array, ...new Array(MIN_LENGTH - array.length).fill(null)] : array;
};
